'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var WidgetUi = (0, _immutable.Record)({
  mobile: false,
  open: false,
  hideWelcomeMessage: false,
  domain: null,
  url: null
});

exports.default = WidgetUi;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/records/WidgetUi.js
// module id = 354
// module chunks = 2 3